import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Modulemaster, ModulemasterData } from '../../../interfaces/masters/modulemaster';
import { ModulemasterApi } from '../api/modulemaster.api';

@Injectable()
export class ModuleMasterService extends ModulemasterData{

  constructor(private api: ModulemasterApi) {
     super();
  }

  list(): Observable<Modulemaster[]> {
    return this.api.list();
  }

  getById(url:string): Observable<Modulemaster>{
      return this.api.getById(url);
  }

  create(url: string, data:Modulemaster): Observable<Modulemaster> {
    return this.api.add(url,data);
  }

  update(url: string, data:Modulemaster): Observable<Modulemaster> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
